import { Navigate } from "react-router-dom";
import { getJwtToken } from "./utils/token";
import { jwtDecode } from "jwt-decode";

/**
 * Wrapper for public/auth routes (e.g. /login). If the visitor already holds a
 * FULL authentication token, bounce them to the dashboard instead of letting
 * them mount the login page. Mounting Login used to revoke the shared Redis
 * session for every open tab (via logoutOnMount), so an already-logged-in user
 * landing on /login would silently log themselves out everywhere.
 *
 * A pre-2FA verification token carries only `userId` (no `email`), so it is NOT
 * treated as authenticated here — the login→2FA flow is unaffected.
 */
const PublicOnlyRoute = ({ children }: { children: JSX.Element }): JSX.Element => {
    const token = getJwtToken();
    if (token) {
        try {
            const decoded: any = jwtDecode(token);
            if (decoded && decoded.email) {
                return <Navigate to="/" replace />;
            }
        } catch {
            // Malformed/empty token — fall through and show the login page.
        }
    }
    return children;
};

export default PublicOnlyRoute;
